import { usePublicKeysStore } from '@systemeio/digital-store-shared';
import { useEffect } from 'react';
import { httpClient } from '../api/http-client';
export const usePublicKeys = (offerId) => {
    const { setStripeAccountId, setMercadoPublicKey, setXenditPublicKey } = usePublicKeysStore();
    useEffect(() => {
        if (!offerId)
            return;
        const fetchPublicKeys = async () => {
            try {
                const { stripeAccountId, mercadoPublicKey, xenditPublicKey } = await httpClient.get(`/api/payment/integration/${offerId}/public-keys`);
                setStripeAccountId(stripeAccountId);
                setMercadoPublicKey(mercadoPublicKey);
                setXenditPublicKey(xenditPublicKey);
            }
            catch (e) {
                console.error(e);
            }
        };
        fetchPublicKeys();
    }, [offerId, setStripeAccountId, setMercadoPublicKey, setXenditPublicKey]);
};
